import * as React from 'react';

import styles from './ReportsStage.scss';

const CHECK_ICON = 'https://static.solartrip.com/images/partners_landing/check_icon.svg';

type ReportsStageListProps = Omit<React.ComponentProps<'ul'>, 'className' | 'style'>;

const ReportsStageList = React.forwardRef<HTMLUListElement, ReportsStageListProps>(
  ({ children, ...props }, ref) => (
    <ul ref={ref} className={styles.list} {...props}>
      {children}
    </ul>
  )
);

ReportsStageList.displayName = 'ReportsStageList';

type ReportsStageListItemProps = Omit<React.ComponentProps<'li'>, 'className' | 'style'>;

const ReportsStageListItem = React.forwardRef<HTMLLIElement, ReportsStageListItemProps>(
  ({ children, ...props }, ref) => (
    <li ref={ref} className={styles.listItem} {...props}>
      {children}
    </li>
  )
);

ReportsStageListItem.displayName = 'ReportsStageListItem';

const ReportsStageCheck = () => (
  <img className={styles.check} src={CHECK_ICON} sizes="30px" alt="Check Icon" />
);

const ReportsStageText = React.forwardRef<HTMLParagraphElement, React.ComponentProps<'p'>>(
  ({ children, ...props }, ref) => (
    <p ref={ref} className={styles.text} {...props}>
      {children}
    </p>
  )
);

ReportsStageText.displayName = 'ReportsStageText';

const List = ReportsStageList;
const ListItem = ReportsStageListItem;
const Check = ReportsStageCheck;
const Text = ReportsStageText;

export {
  ReportsStageList,
  ReportsStageListItem,
  ReportsStageCheck,
  ReportsStageText,
  //
  List,
  ListItem,
  Check,
  Text,
};
